import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage-angular';
import { RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ContentProvider } from 'src/providers/content-provider/content-provider';
import { AppRoutingModule} from "./app-routing.module";
import { AppComponent } from './app.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from "./appSettings";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import localeDe from "@angular/common/locales/de";
import { registerLocaleData, CommonModule, NgIf, NgFor } from "@angular/common";
import { APP_BASE_HREF, LocationStrategy } from "@angular/common";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GoogleTagManagerModule} from 'angular-google-tag-manager';
import { TagManager } from 'src/providers/google-tracking/google-tag-manager';
//import {AppRate} from "@awesome-cordova-plugins/app-rate/ngx";
//import { ScanBMPModal } from 'src/pages/patmedlist-new/scanBMPModal/scanBMP-modal';
import { CountrySelectorPopoverComponent } from '../components/common/country-selector-popover.component';
import { SearchBarComponent } from 'src/components/search-bar/search-bar.component';


registerLocaleData(localeDe);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
    declarations: [AppComponent, CountrySelectorPopoverComponent, SearchBarComponent, /*ScanBMPModal*/],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [CommonModule, NgIf, NgFor, RouterModule, IonicStorageModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
        }),
        FormsModule, 
        ReactiveFormsModule, 
        BrowserModule, 
        IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }), 
        AppRoutingModule, 
        GoogleTagManagerModule.forRoot({id: 'GTM-MNJGH4WS',}),
        IonicStorageModule.forRoot()
    ],
    providers: [
        //BarcodeScanner,
       /*  AppRate, */
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LocationStrategy, useClass: AppSettings.LocationStrategy },
        { provide: APP_BASE_HREF, useValue: AppSettings.APP_BASE_HREF },
        { provide: LOCALE_ID, useValue: 'de-DE' },
        ContentProvider,
        TagManager,
        provideHttpClient(withInterceptorsFromDi())
    ],
    exports: [CommonModule, FormsModule, TranslateModule],
})
export class AppModule { }
